(() => {
  const desktop = window.matchMedia('(min-width: 990px)');
  const root = document.documentElement;
  const heroSection = document.querySelector('main > [id$="__image_banner"]');
  const collectionSection = document.querySelector('main > [id$="__collection_strip_main"]');
  const experienceSection = document.querySelector('main > [id$="__experience_columns"]');
  if (!heroSection || !collectionSection || !experienceSection) return;

  const sizeStages = () => {
    if (!desktop.matches) {
      root.style.removeProperty('--ss-home-hero-height');
      return;
    }

    const headerHeight = heroSection.getBoundingClientRect().top + window.scrollY;
    const collectionHeight = collectionSection.getBoundingClientRect().height;
    const heroHeight = Math.max(0, window.innerHeight - headerHeight - collectionHeight);

    root.style.setProperty('--ss-home-hero-height', `${heroHeight}px`);
  };

  let frame;
  const scheduleSize = () => {
    window.cancelAnimationFrame(frame);
    frame = window.requestAnimationFrame(sizeStages);
  };

  window.addEventListener('resize', scheduleSize, { passive: true });
  desktop.addEventListener('change', scheduleSize);

  if ('ResizeObserver' in window) {
    const observer = new ResizeObserver(scheduleSize);
    observer.observe(collectionSection);
  }

  let scrollLocked = false;
  const stageElements = [
    document.querySelector('#shopify-section-announcement-bar'),
    document.querySelector('main > [id$="__1783531760acfd4cff"]'),
    experienceSection
  ].filter(Boolean);

  const moveOneStage = (direction) => {
    const points = stageElements.map((element) => element.getBoundingClientRect().top + window.scrollY);
    let currentIndex = 0;
    let closestDistance = Infinity;

    points.forEach((point, index) => {
      const distance = Math.abs(window.scrollY - point);
      if (distance < closestDistance) {
        closestDistance = distance;
        currentIndex = index;
      }
    });

    const nextIndex = Math.max(0, Math.min(points.length - 1, currentIndex + direction));
    if (nextIndex === currentIndex) return false;

    scrollLocked = true;
    window.scrollTo({
      top: points[nextIndex],
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
    });
    window.setTimeout(() => {
      scrollLocked = false;
    }, 800);
    return true;
  };

  window.addEventListener('wheel', (event) => {
    if (!desktop.matches || scrollLocked || Math.abs(event.deltaY) < 8) return;
    const finalStageTop = stageElements[stageElements.length - 1].getBoundingClientRect().top + window.scrollY;
    if (window.scrollY > finalStageTop + 8) return;
    if (moveOneStage(event.deltaY > 0 ? 1 : -1)) event.preventDefault();
  }, { passive: false });

  sizeStages();
})();
